import "./styles/whiteFlash.css";

interface WhiteFlashProps {
	isShowWhiteFlash: boolean;
}

export function WhiteFlash({ isShowWhiteFlash }: WhiteFlashProps) {
	return <div id="white-flash" className={`${isShowWhiteFlash ? "do-transition" : ""} normal`} />;
}

export default WhiteFlash;
